import React from "react";
import { useIntl } from "react-intl";
import { Row, Button, Badge, Form } from "@masterteam/mt-design-react";

const { Field } = Form;

function ParameterItem({ index, removeItem, isEditMode, isReadOnly, data }) {
  const intl = useIntl();

  return (
    <Row size="small" align="center">
      <Badge variant="dark" shape="circle">
        {index + 1}
      </Badge>

      <div style={{ flex: 1 }}>
        <Field
          name={`Parameters[${index}].ParameterName`}
          label={intl.formatMessage({ id: "kpi.parameter-name" })}
          disabled
          inputProps={{
            placeholder: intl.formatMessage({ id: "kpi.parameter-name" }),
            value: data?.ParameterName,
          }}
          hideErrorMessage
        />
      </div>

      <div style={{ flex: 2 }}>
        <Field
          label={intl.formatMessage({
            id: "kpi.parameter-description",
          })}
          name={`Parameters[${index}].Description`}
          disabled
          inputProps={{
            placeholder: intl.formatMessage({
              id: "kpi.parameter-description",
            }),
            value: data?.Description,
          }}
          hideErrorMessage
        />
      </div>
    </Row>
  );
}

export default ParameterItem;
